'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Checkbox = function (_React$Component) {
  (0, _inherits3.default)(Checkbox, _React$Component);

  function Checkbox() {
    (0, _classCallCheck3.default)(this, Checkbox);
    return (0, _possibleConstructorReturn3.default)(this, (Checkbox.__proto__ || (0, _getPrototypeOf2.default)(Checkbox)).apply(this, arguments));
  }

  (0, _createClass3.default)(Checkbox, [{
    key: 'render',
    value: function render() {
      var _classnames;

      var styles = require('./Checkbox.scss');

      var inputFieldAttrs = {};
      if (this.props.onChange) inputFieldAttrs.onChange = this.props.onChange;
      if (this.props.form) inputFieldAttrs.form = this.props.form;
      if (this.props.name) inputFieldAttrs.name = this.props.name;
      if (this.props.checked) {
        inputFieldAttrs.checked = true;
      } else {
        inputFieldAttrs.checked = false;
      }

      var inputField = _react2.default.createElement('input', (0, _extends3.default)({ type: 'checkbox' }, inputFieldAttrs));

      var classes = (0, _classnames3.default)((_classnames = {}, (0, _defineProperty3.default)(_classnames, styles.Checkbox, true), (0, _defineProperty3.default)(_classnames, styles['Checkbox--with-label'], !!this.props.label), (0, _defineProperty3.default)(_classnames, this.props.className, !this.props.label), _classnames));

      var customCheckbox = _react2.default.createElement(
        'span',
        { className: classes },
        inputField,
        _react2.default.createElement('span', { className: styles.Checkbox__bar })
      );

      var labelAttrs = {};
      if (this.props.className) labelAttrs.className = this.props.className;

      return this.props.label ? _react2.default.createElement(
        'label',
        labelAttrs,
        this.props.label,
        customCheckbox
      ) : customCheckbox;
    }
  }]);
  return Checkbox;
}(_react2.default.Component);

Checkbox.propTypes = {
  name: _react2.default.PropTypes.string,
  label: _react2.default.PropTypes.string,
  checked: _react2.default.PropTypes.bool,
  className: _react2.default.PropTypes.string,
  form: _react2.default.PropTypes.string,
  onClick: _react2.default.PropTypes.func
};

exports.default = Checkbox;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Checkbox/Checkbox.jsx
// module id = 2342
// module chunks = 0